// variantes del gancho para probar: añade #v1 … #v5 al final del enlace
(function(){
  const V={
    v1:{pre:'',t:['Para bajar de peso después del parto,','deja de comer tan poco.'],s:'Come lo suficiente, muévete 15 minutos al día y baja sin afectar tu leche.'},
    v6:{pre:'Son las 3:17 de la mañana y tienes hambre otra vez.',t:['Te dijeron que dando pecho','bajarías sola.'],s:'Si a ti no te pasó, no es tu culpa: dar pecho te da más hambre de la que quema. Esta guía de 30 días te enseña a bajar de peso después del parto sin afectar tu leche, con 15 minutos al día.'},
    v2:{pre:'Si das pecho, esto te interesa.',t:['¿Cuánto puedes comer para bajar de peso','sin perder leche?'],s:'Lo calculas en 4 pasos, con un mínimo que protege tu producción. Además: 5 ejercicios seguros para tu abdomen y un menú latino de 7 días.'},
    v3:{pre:'¿Tu bebé ya tiene meses y los jeans siguen sin cerrar?',t:['No es falta de ganas.','Te falta un plan para esta etapa.'],s:'Duermes poco, das pecho y comes cuando puedes. Esta guía de 30 días está hecha justo para eso: 15 minutos al día, sin dietas estrictas y sin afectar tu leche.'},
    v4:{pre:'Si quieres volver a tus jeans de antes,',t:['empieza por lo que','nadie te enseñó.'],s:'Antes de quemar grasa hay que volver a activar el abdomen que estiró el embarazo. Esta guía de 30 días te enseña cómo, sin afectar tu leche y con 15 minutos al día.'},
    v5:{pre:'Son las 3:17 de la mañana.',t:['Nunca perdiste','tu cuerpo.'],s:'Una guía de 30 días para empezar a bajar de peso después del parto, sin afectar tu leche y con solo 15 minutos al día.'}
  };
  const k=(location.hash||'').replace('#','')||(window.VAM_VARIANTE||'v1');
  const v=V[k]; if(!v) return;
  const pr=document.getElementById('hPre');pr.textContent=v.pre;pr.hidden=!v.pre;
  const h=document.getElementById('hTit');
  h.innerHTML='';const a=document.createElement('span');a.textContent=v.t[0];const b=document.createElement('span');b.className='brillo';b.textContent=v.t[1];h.append(a,b);
  document.getElementById('hSub').textContent=v.s;
})();
(function(){
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cab=document.getElementById('cabecera');
  const barra=document.getElementById('barraMovil');
  const ap=document.getElementById('apertura');
  const capas=[...ap.querySelectorAll('.capa')];
  const textos=[...ap.querySelectorAll('.texto')];
  const contador=document.getElementById('contador');
  const dias=[1,10,20,30];
  let activo=0;
  function marco(){
    const y=window.scrollY;
    cab.classList.toggle('solida',y>40);
    const fin=ap.offsetTop+ap.offsetHeight-window.innerHeight;
    barra.classList.toggle('visible',y>fin-200);
    if(reduce) return;
    const total=ap.offsetHeight-window.innerHeight;
    const p=Math.min(1,Math.max(0,(y-ap.offsetTop)/Math.max(1,total)));
    const pos=p*(capas.length-1);
    capas.forEach((c,i)=>{
      const d=Math.abs(pos-i);
      const o=Math.max(0,Math.min(1,1.6-d*1.6));
      c.style.opacity=i===0&&pos<0.01?1:o;
      const local=Math.max(-1,Math.min(1,pos-i));
      c.style.transform=`scale(${1.1-0.06*(local+1)})`;
    });
    ap.style.setProperty('--p',p.toFixed(4));
    ap.querySelector('.tinte').style.setProperty('--tinte',(0.15+p*0.55).toFixed(3));
    const dia=Math.max(1,Math.min(30,Math.round(1+p*29)));
    contador.textContent='Día '+dia;
    const n=Math.min(textos.length-1,Math.round(pos));
    if(n!==activo){textos[activo].classList.remove('activo');textos[n].classList.add('activo');activo=n;}
  }
  let pend=false;
  window.addEventListener('scroll',()=>{if(!pend){pend=true;requestAnimationFrame(()=>{marco();pend=false;});}},{passive:true});
  window.addEventListener('resize',marco);
  marco();
})();